export enum ForgotPasswordTranslations {
  title = 'forgotPassword.title',
  description = 'forgotPassword.description',
  buttonResetPassword = 'forgotPassword.buttonResetPassword',
  backToLogIn = 'forgotPassword.backToLogIn',
  successMessage = 'forgotPassword.successMessage',

}
